import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';

import defaultMedicSvg from '../../../../../assets/img/next/svg/medic.svg';
import cabinetSvg from '../../../../../assets/img/next/svg/cabinet.svg';
import screeningLogoSmall from '../../../../../assets/img/skrinig40_52x48.svg';

import Photo from './photo';

import DesktopSchedule from './schedule/DesktopSchedule';
import useDoctorApi from '../../../../doctorPage/common/Doctor/api';
import Appointment from '../../../../../containers/Appointment';
import { Modal } from 'react-bootstrap';
import DoctorPage from '../../../../../containers/DoctorPage';

import { useDispatch } from 'react-redux';

export default function Doctor({
  doctorSchedule,
  doctor,
  full_name,
  job,
  photo,
  jobDoctorScheduleDays,
  jobDoctorScheduleSlots,
  searchFilters,
  setSearchFilters,
  city,
  isVaccinates = false,
  isOperator = false,
  disableOwnLink = false,
  websiteCovidSource = null,
  patients,
  loading,
  user,
}) {
  
  const dispatch = useDispatch();

  const {
    timeSlot,
    setTimeSlot,
    isDirect,
  } = useDoctorApi({ jobs: job ? [job] : [] }); // Pass job as an array for compatibility
 
  const [showDoctorModal, setShowDoctorModal] = useState(false);
 
  const [docСalendarDate, setDocСalendarDateState] = useState(null);
  
  // Helper function to build filter query params
  const buildFilterParams = () => {
    let params = '';
    if (searchFilters?.visit_date) {
      params += `&calendar_date=${searchFilters.visit_date}`;
    }
    if (searchFilters?.onlyAvailable) {
      params += '&onlyAvailable=true';
    }
    if (searchFilters?.byReferral) {
      params += '&byReferral=true';
    }
    if (searchFilters?.screening_40_plus) {
      params += '&screening_40_plus=true';
    }
    if (searchFilters?.defencer_benefit) {
      params += '&defencer_benefit=true';
    }
    return params;
  };
  
  // Custom function that updates date state and opens the modal
  const setDocСalendarDate = (date) => {
    setDocСalendarDateState(date);
    handleLinkClick();
  };

  const handleLinkClick = (e) => {
    if(e) e.preventDefault();
    dispatch({ type: 'RESET_DOCTOR' });
    dispatch({ type: 'RESET_DOCTOR_SCHEDULES' });
    dispatch({ type: 'RESET_DOCTORS_BY_DAYS_SCHEDULES' });
    setShowDoctorModal(true);
  };
  
  return (
    <div className="feature-card__item">
      <Appointment
        isOperator={isOperator}
        isVaccinates={isVaccinates}
        websiteCovidSource={websiteCovidSource}
        doctor={doctor}
        job={job}
        timeSlot={timeSlot}
        isOpen={!!timeSlot}
        searchFilters={searchFilters}
        onClose={() => setTimeSlot(null)}
        jobDoctorScheduleDays={jobDoctorScheduleDays}
      />

      {showDoctorModal && (
        <Modal style={{ zIndex: 1030 }} backdropClassName="custom-backdrop" show={showDoctorModal} onHide={() => setShowDoctorModal(false)} centered className="doctor-modal">
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DoctorPage
              doctorId={doctor.id}
              currentjobId={job?.id}
              currentDate={docСalendarDate}
              user={user}
              patients={patients ? { data: patients } : undefined}
              isModal={true}
              searchFilters={searchFilters}
              onClose={() => { setShowDoctorModal(false); dispatch({ type: 'HIDE_ALERT_MESSAGE' }); }}
              jobDoctorScheduleDays={jobDoctorScheduleDays}
            />
          </Modal.Body>
        </Modal>
      )}

      <div className="medic-feature-profile" onClick={handleLinkClick}>
        <div className="medic-feature-profile-status">
          <Photo 
            photo={doctor.is_virtual ? cabinetSvg : searchFilters?.screening_40_plus ? screeningLogoSmall : photo} 
            defaultPhoto={defaultMedicSvg} 
            isScreeningLogo={doctor.is_virtual || searchFilters?.screening_40_plus}
          />
        </div>

        <div className="medic-feature-profile-information">
          <div className="medic-feature-profile-information__title">
            <NavLink
              to={`/city/${job?.institution?.city_id || city?.id}/doctors/${doctor.id}?job_id=${job?.id}${buildFilterParams()}`}
              disabled={disableOwnLink}
              onClick={handleLinkClick}
              className={`${disableOwnLink ? 'disabled' : ''}`}
            >
              {doctor.is_virtual
                ? job?.cabinet_name
                  ? job.cabinet_name
                  : job?.cabinet_num
                    ? `Кабінет №${job.cabinet_num}`
                    : 'Кабінет'
                : searchFilters?.screening_40_plus
                  ? `Кабінет скринінгу ${job?.cabinet_num ? '№' + job.cabinet_num : ''}`
                  : full_name}
            </NavLink>
          </div>
          {(
              <div className="job-location-title">
                  <NavLink
                    to={`/city/${job?.institution?.city_id || city?.id}/doctors/${doctor.id}?job_id=${job?.id}${buildFilterParams()}`}
                    disabled={disableOwnLink}
                    onClick={handleLinkClick}
                    className={`${disableOwnLink ? 'disabled' : ''}`}
                  >
                    {job.institution.name}
                  </NavLink>
                  <div className="division-address">{job?.division?.address?.display_text || ''}</div>
              </div>
          )}
        </div>
      </div>

      {(city == null || Boolean(city?.settings?.allow_timeslots)) && !isVaccinates && (
            <DesktopSchedule
              key={`${doctor.id}-${job.id}`}
              doctor={doctor}
              job={job}
              onOpenAppointment={setTimeSlot}
              
              datesRange={doctorSchedule.datesRange}
              jobDoctorScheduleSlots={jobDoctorScheduleSlots}
              jobDoctorScheduleDays={jobDoctorScheduleDays}
              loading={loading}
              
              isDirect={isDirect}
              setDocСalendarDate={setDocСalendarDate}
              searchFilters={searchFilters}
              patients={patients}
            />
      )}
    </div>
  );
}
